import { openURLInNewTab } from 'utils/navigation';

import { LoanClosingSearchParams } from '../../LoanClosingCDS.constants';

export const openCurrentPageInNewTab = () => {
  openURLInNewTab(window.location.href);
};

export const removeAmortizationSearchParam = (history, isModalOpenRef) => {
  isModalOpenRef.current = false;

  const url = new URL(window.location.href);

  url.searchParams.delete(LoanClosingSearchParams.AMORTIZATION_SCHEDULE);
  history.replace(`${url.pathname}${url.search}`);
};

export const getFormattedTableData = estimatedPayments => {
  if (!estimatedPayments?.length) {
    return [];
  }

  return estimatedPayments.map((item, index) => ({
    ...item,
    id: item.id ?? index,
  }));
};
